import ToolStylus from './ToolStylus';
import Shortcut from '../utils/Shortcut';

class ToolStylusNote extends ToolStylus {
  static toolName = 'Note';
  static shortcut = new Shortcut('N');

  static action({ controller }) {
    controller.actionSetStylus(controller.stylusNote);
  }
}

export default ToolStylusNote;
